// react imports
import { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { InputNumber, Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import axios from "axios";

// common imports
import { API_URL } from "common/constants/config";

import CategoryHeader from "./CategoryHeader";
import "./css/Pagination.css";
import "./css/Table.css";

function Water() {
  interface WaterInputs {
    costPerM3: number;
    co2EmissionPerM3: number;
  }

  interface WaterData extends WaterInputs {
    key: string;
  }

  const [water, setWater] = useState<WaterData[]>([]);
  const { control, handleSubmit } = useForm<WaterInputs>();

  const columns: ColumnsType<WaterData> = [
    {
      title: "",
      key: "water",
      dataIndex: "water",
      align: "center",
      width: 209,
      render: () => "Agua",
    },
    {
      title: "€/m3",
      key: "costPerM3",
      dataIndex: "costPerM3",
      align: "center",
      width: 219,
      render: (value) => (
        <Controller
          name="costPerM3"
          control={control}
          defaultValue={value}
          render={({ field }) => (
            <InputNumber
              {...field}
              decimalSeparator=","
              onPressEnter={handlePressEnter}
            />
          )}
        />
      ),
    },
    {
      title: "kgCO2/m3",
      key: "co2EmissionPerM3",
      dataIndex: "co2EmissionPerM3",
      align: "center",
      width: 231,
      render: (value) => (
        <Controller
          name="co2EmissionPerM3"
          control={control}
          defaultValue={value}
          render={({ field }) => (
            <InputNumber
              {...field}
              decimalSeparator=","
              onPressEnter={handlePressEnter}
            />
          )}
        />
      ),
    },
  ];

  function handlePressEnter(e: React.KeyboardEvent<HTMLInputElement>) {
    e.preventDefault();
  }

  async function onSubmit(values: WaterInputs) {
    const payload = {
      water: values,
    };

    await axios.put("/admin/calculator/household-habits", payload, {
      baseURL: API_URL,
    });
  }

  async function fetchWaterValues() {
    const {
      data: {
        householdHabits: { water: waterValues },
      },
    } = await axios.get(`${API_URL}/admin/calculator/household-habits`);

    const { co2EmissionPerM3, costPerM3 } = waterValues;
    setWater([
      {
        key: costPerM3 + co2EmissionPerM3,
        co2EmissionPerM3,
        costPerM3,
      },
    ]);
  }

  useEffect(() => {
    fetchWaterValues();
  }, []);

  return (
    <>
      <CategoryHeader title="Agua" showSaveButton formName="water" />
      <form id="water" onSubmit={handleSubmit(onSubmit)}>
        <Table columns={columns} dataSource={water} pagination={false} />
      </form>
    </>
  );
}

export default Water;
